import { Item, Zone } from '@types'
import { Group, Mesh, Texture } from 'three'
import { ObjectMesh } from './ObjectMesh'

// Interfaz para el resultado del análisis de muebles contiguos
interface ContiguousAnalysisResult {
  groups: object[][]
  totalGroups: number
  totalItemsInGroups: number
}

type ObjectGroupProps = {
  node: Group
  zones: Zone
  morphs: Item['morphs']
  textures?: Item['textures']
  renderTarget?: Texture
  paginaPdf?: number | undefined
  itemHeight?: number
  itemWidth?: number
  itemThickness?: number
  getContiguousItems?: () => ContiguousAnalysisResult
  fatherId?: string
  universal?: boolean
  itemId?: string
}
export function ObjectGroup({
  node,
  zones,
  morphs,
  textures,
  renderTarget,
  paginaPdf,
  itemHeight,
  itemWidth,
  itemThickness,
  getContiguousItems,
  fatherId,
  universal,
  itemId,
}: ObjectGroupProps) {
  const { name, uuid, children, userData, ...rest } = node

  return (
    <>
      <group
        key={`${uuid}-${name}-group`}
        {...rest}
      >
        {node?.children?.map((node: Node) => {
          if (node instanceof Group) {
            return (
              <ObjectGroup
                key={node.uuid + '-object-group'}
                node={node}
                morphs={morphs}
                zones={zones}
                textures={textures}
                renderTarget={renderTarget}
                paginaPdf={paginaPdf}
                itemHeight={itemHeight}
                itemWidth={itemWidth}
                itemThickness={itemThickness}
                getContiguousItems={getContiguousItems}
                fatherId={fatherId}
                universal={universal}
                itemId={itemId}
              />
            )
          }
          if (node instanceof Mesh) {
            return (
              <ObjectMesh
                key={node.uuid + 'object-mesh'}
                node={node}
                zones={zones}
                morphs={morphs}
                textures={textures}
                renderTarget={renderTarget}
                paginaPdf={paginaPdf}
                itemHeight={itemHeight}
                itemWidth={itemWidth}
                itemThickness={itemThickness}
                getContiguousItems={getContiguousItems}
                fatherId={fatherId}
                universal={universal}
                itemId={itemId}
              />
            )
          }
        })}
      </group>
    </>
  )
}
